<script>
  import Modal from "../../../../../shared/javascripts/svelte/Components/Modal.svelte";
  import Icon from "../../../../../shared/javascripts/svelte/Components/Icon.svelte";
  export let showFirstTimeModal;
  export let onCloseFirstTimeModal;

  function done() {
    showFirstTimeModal = false;
    localStorage.setItem("has_seen_sdo_explainer_modal", true);
    onCloseFirstTimeModal();
  }

</script>

<Modal bind:show={showFirstTimeModal} closeOnBackgroundClick={false}>
  <div
    class="background-white welcome-modal padding--medium align-center"
    style="width: 90vw; max-width: 600px;"
  >
    <div class="problematic-choice-modal__header full-width">
      <Icon
        type="Truck"
        height="60"
        width="60"
        color="darkgray"
        extraClassNames="media-fixed align-self-center"
      />
      <div class="default-title--bold margin-top--smaller margin-bottom--small">
        Start by Connecting your Distributors
      </div>
    </div>
    <div class="problematic-choice-modal_distributor-container full-width">
      <div
        class="problematic-choice-modal_distributor-list list list--vertical list--gutter-smallest list--align-middle full-width align-center"
      >
        <div class="s4">
          Connect your distributors to unlock the greatest time saving benefit of Provi: ordering
          from all of your reps in just one click.
        </div>
        <div class="s4 padding-top--small">
          Get started by selecting <span class="default-body--bold">Connect a Distributor</span>
        </div>
      </div>
    </div>
  </div>
  <footer class="modal__footer align-right padding--smaller">
    <div class="grid-row">
      <div class="grid-col c12-10 align-right">
        <button class="button button--small button--primary" on:click={done}>Got it</button>
      </div>
    </div>
  </footer>
</Modal>
